// extracted by mini-css-extract-plugin
export default {"buttonContainer":"AgeGroups_buttonContainer__8F3RT","checkboxLabel":"AgeGroups_checkboxLabel__RtIpq"};